<template>
    <div class="container">
        <Query :searchPropLoading="loading"  @query-click="handleQueryClick"/>
        <div class="bg-white pt10 pl10 pr10 pb10 borderRadius5 order_table_no_border">
            <div class="operation-box mb10">
                <div class="operation-left">
                    <div style="display: flex;align-items: center;">
                        <el-button v-permission="['add_compare']" type="primary" size="mini" class="mr10" @click="handleInner">插入比对</el-button>
                        <el-dropdown @command="handleCommand" v-permission="['operation_the_same','operation_diff']">
                            <el-button type="primary" size="mini" plain>
                                批量编辑<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="1" v-permission="['operation_the_same']">相同</el-dropdown-item>
                                <el-dropdown-item command="2" v-permission="['operation_diff']">不同</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <p class="pl10" v-permission="['operation_the_same','operation_diff']">已选中{{multipleSelection.length}}条</p>
                    </div>
                </div>
                <div class="operation-right">

                </div>
            </div>
            <jt-table
                :data="tableData"
                style="width: 100%"
                :header-cell-style="{ background: '#e8eaec', color: '#333' }"
                size="mini"
                @selection-change="handleSelectionChange"
                header-cell-class-name="header-cell"
                class="setSortHeight"
                stripe
                ref="refs_table"
                
                v-loading="loading"
            >
                <!-- 默认 -->
                <el-table-column
                    v-if="pageFuncNames.includes('operation_the_same') || pageFuncNames.includes('operation_diff')"
                    type="selection"
                    width="55"
                    fixed="left"
                >
                </el-table-column>
                <el-table-column
                    :prop="column.id"
                    :label="column.display_name"
                    :min-width="column.width"
                    :fixed="column.fixed !='' ? column.fixed : false"
                    v-for="(column) in columns"
                    :key="column.id"
                    align="center"
                >
                    <template slot-scope="scope">
                        <div v-if="column.id=='action'">
                            <div>
                                <el-button type="primary" plain size="mini" v-if="scope.row.status == 0 || scope.row.status == 2"
                                :loading="scope.row.sameLoading"
                                :disabled="scope.row.diffLoading"
                                v-permission="['operation_the_same']"
                                @click="handleSame(scope.row, scope.$index)">相同</el-button>
                            </div>
                            <div style="margin-top: 5px;">
                                <el-button type="danger" plain size="mini" v-if="scope.row.status == 0 || scope.row.status == 1"
                                :loading="scope.row.diffLoading"
                                :disabled="scope.row.sameLoading"
                                v-permission="['operation_diff']"
                                @click="handleDiff(scope.row, scope.$index)">不同</el-button>
                            </div>
                            <span v-if="isAuthData(scope.row)">-</span>
                        </div>

                        <div v-else-if="column.id === 'material_url' || column.id === 'plat_material_url'" :key="scope.row[column.id]">
                            <span v-if="!scope.row[column.id]">-</span>
                            <showImg v-else :url="scope.row[column.id]" @click="handlePrew(scope.row)"/>
                        </div>
                        <div v-else-if="column.id === 'status_text'">
                            <span :style="{color: scope.row.status_text_color}">{{scope.row[column.id]}}</span>
                        </div>
                         <div v-else-if="column.id === 'compare_detail'" class="tac">
                            <HoverEllipsisTips :text="scope.row[column.id]"/>
                            <img 
                                alt="加载失败"
                                v-if="scope.row.img_path_for_diff" 
                                :src="scope.row.img_path_for_diff" 
                                style="max-width: 100%; max-height: 50px"
                                @error="($event)=>scope.row.img_path_for_diff= errorImg"
                                @click="()=>showImgViewer(scope.row.img_path_for_diff)"
                            />
                        </div>
                        <div v-else-if="['create_time','edit_time'].includes(column.id)">
                            <div v-for="(item ,index) in scope.row[`${column.id}_split`]" :key="index">
                                {{item}}
                            </div>
                        </div>
                        <div v-else @dblclick="()=>handleCopyText(scope.row[column.id], column.id)">
                            <HoverEllipsisTips :text="scope.row[column.id]"/>
                        </div>
                    </template>
                </el-table-column>
            </jt-table>
            <div class="tar pt20 pr20">
                <el-pagination 
                    @size-change="handleSizeChange" 
                    @current-change="handleCurrentChange"
                    :current-page="pageNum" 
                    :page-sizes="[30, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" 
                    :total="total"
                />
            </div>
        </div>
        <ElImageViewer
            v-if="imgViewerVisible"
            :on-close="closeImgViewer"
            :url-list="imageViewerList"
        />
    </div>
</template>
<script>
import Query from './query.vue'
import showImg from './components/showImg.vue';
import HoverEllipsisTips from "@/views/workOrder/components/hoverEllipsis.vue";
import {diffInfoModal, prewModal} from './modal'
import errorImg from '@/assets/img/error.png'
import utils from '@/libs/utils.js';
import {compareGetListApi, compareOperationSameApi, compareOperationDiffApi, compareBatchOperationSameApi, compareBatchOperationDiffApi} from '@/api/systemTool/compare'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
const body = document.body;
export default {
    name: 'diffpage',
    props: [ 'pageFuncNames' ],
    components: {
        Query,
        showImg,
        HoverEllipsisTips,
        ElImageViewer
    },
    data() {
        return {
            errorImg,
            searchLoading: false,
            pageSize: 30,
            pageNum: 1,
            total: 0,
            loading: false,
            queryData:{},
            columns:[
                {
                    id: 'id',
                    display_name: 'ID',
                    width: '100'
                },
                {
                    id: 'plat_name',
                    display_name: '媒体',
                    width: '100'
                },
                {
                    id: 'material_url',
                    display_name: '玩咖素材',
                    width: '100'
                },
                {
                    id: 'plat_material_url',
                    display_name: '媒体素材',
                    width: '100'
                },
                {
                    id: 'action',
                    display_name: '操作',
                    width: '100'
                },
                {
                    id: 'account_id',
                    display_name: '账户ID',
                    width: '100'
                },
                {
                    id: 'ad_id',
                    display_name: '广告ID',
                    width: '100'
                },
                {
                    id: 'status_text',
                    display_name: '比对结果',
                    width: '100'
                },
                {
                    id: 'compare_detail',
                    display_name: '比对详情',
                    width: '100'
                },
                {
                    id: 'create_user',
                    display_name: '创建人',
                    width: '100'
                },
                {
                    id: 'create_time',
                    display_name: '创建时间',
                    width: '120'
                },
                {
                    id: 'edit_user',
                    display_name: '最新编辑人',
                    width: '100'
                },
                {
                    id: 'edit_time',
                    display_name: '最新编辑时间',
                    width: '120'
                }
            ],
            tableData:[],
            multipleSelection: [],
            imgViewerVisible: false,
            imageViewerList: []
        }
    },
    created() {
    },
    mounted() {
    },
    methods: {
        isAuthData(row) {
            if (!(this.pageFuncNames.includes('operation_diff') || this.pageFuncNames.includes('operation_the_same'))) {
                return true;
            };
            if (!this.pageFuncNames.includes('operation_diff') && ['1'].includes(row.status) ) {
                return true;
            }
            if (!this.pageFuncNames.includes('operation_the_same') && ['2'].includes(row.status)) {
                return true;
            }
            return false;
        },
        showImgViewer(url) {
            
            body.classList.add('f-hide')
            this.imgViewerVisible = true;
            this.imageViewerList = [ url ]
        },
        closeImgViewer() {
            body.classList.remove('f-hide')
            this.imgViewerVisible = false;
            this.imageViewerList = []
        },
        handleCopyText(copyTxt, id) {
            if (!['account_id', 'ad_id'].includes(id)) {
                return;
            }
            utils.setClipboardText(copyTxt);
            this.$message({
                message: '复制成功',
                type: 'success'
            });
        },
        handleQueryClick(params) {
            this.pageNum = 1;
            this.queryData = params
            this.fetchList()
        },
        async fetchList() {
            this.loading = true;
            
            let res_params = {...this.queryData,pn:this.pageNum, rn:this.pageSize};
            try {
                let { data } = await compareGetListApi(res_params)
                // create_time edit_time
                this.tableData = data.list.map(v=> {
                    return {
                        ...v,
                        status_text_color: v.status === '0'?'grey': v.status === '1'?'green':'red',
                        diffLoading: false,
                        sameLoading: false,
                        create_time_split: v.create_time.split(' '),
                        edit_time_split: v.edit_time.split(' '),
                    }
                })
                this.total = data.totalCnt
                this.loading = false  
            } catch (error) {
                this.$message.error(error.info || error.message)
            }finally {
                this.loading = false  
            }
        },
        // 勾选
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        async handleSame(row, index) {
            try {
                row.sameLoading = true;
                await compareOperationSameApi({id:row.id, status: 1});
                if (!this.queryData.status.includes('1') && this.pageNum >1 && this.tableData.length === 1) {
                    --this.pageNum;
                }
                this.fetchList()
            } catch (error) {
                this.$message.error(error.info || error.message)
            }finally {
                row.sameLoading = false
            }
        },
        async handleDiff(row) {
            try {
                row.diffLoading = true
                await compareOperationDiffApi({id:row.id, status: 2});
                if (!this.queryData.status.includes('2') && this.pageNum >1 && this.tableData.length === 1) {
                    --this.pageNum;
                }
                this.fetchList();
            } catch (error) {
                this.$message.error(error.info || error.message)
            }finally {
                row.diffLoading = false
            }
        },
        // 批量操作
        async handleCommand(val) {
            if(this.multipleSelection.length === 0) return this.$message.warning('请选择操作项')
            let ids = this.multipleSelection.map(item=>item.id).join(',')
            await this.$confirm(`您确认要将选择的的素材全部都修改为【${val == '1'? '相同': '不同'}】吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            });
            try {
                
                if (val == '1') {
                    await compareBatchOperationSameApi({id:ids, status: val});
                }else {
                    await compareBatchOperationDiffApi({id:ids, status: val})
                }
                const list = this.multipleSelection.filter(v=>v.status !== val);
                if (list.length === this.tableData.length && this.pageNum > 1) {
                    --this.pageNum;
                }
                this.$refs.refs_table.clearSelection();
                this.fetchList();
            } catch (error) {
                this.$message.error(error.info || error.message)
            }
        },
        // 插入对比
        handleInner() {
            const {vm} = diffInfoModal(
                {
                    props: {
                        id: 1
                    },
                    cbs:{
                        onSubmit:(data)=>{
                            this.pageNum = 1;
                            this.fetchList();
                            vm.close()
                        },
                    }
                }
            )
        },
        // 预览
        handlePrew(row) {
            const {vm} = prewModal(
                {
                    
                    props: {
                        id: row.id,
                        title: `ID: ${row.id}, 比对结果: ${row.status_text}`,
                        status: row.status
                    },
                    cbs:{
                        onSame:(data)=>{
                            this.handleSame(row)
                            vm.close()
                        },
                        onDiff:(data)=>{
                            this.handleDiff(row)
                            vm.close()
                        },
                    }
                }
            )
        },
        // 每页条数
        handleSizeChange(val) {
            this.pageSize = val
            this.fetchList()
        },
        // 当前页数
        handleCurrentChange(val) {
            this.pageNum = val
            this.fetchList()
        },
    }
}
</script>
<style lang="scss" scoped>
@import "~@/styles/material_sd.scss";
.disabledBtn{
    cursor: no-drop;
    color: #dadada !important;
}
</style>
<style>
.custom-indicator-new{
    min-width: 900px;
}
</style>